import { useState, useEffect, useRef } from 'react';
import { useViewport } from 'hooks/3catinfo/useViewport';
import { useModal } from 'hooks/3catinfo/useModal';
import Mosaic from 'components/3catinfo/Mosaic';
import Imatge from 'components/3catinfo/Imatge';
import styles from './llistatelectes.module.scss';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';

const getLogoPartit = (partit) => {
    partit = partit.replace(/[^a-zA-Z0-9_-\s]/g, '').replace(' ', '-');
    return `${partit}.jpg`;
};

const ModalLlistat = (props) => {
    const { item, pathLogos, removeModal, mostraLogoPartits } = props;
    const { canditats, id, mnumitems, nom, rgbcolor } = item;
    const containerRef = useRef(null);
    const [showOpacityLayerTop, setShowOpacityLayerTop] = useState(false);
    const [showOpacityLayerBottom, setShowOpacityLayerBottom] = useState(false);

    useEffect(() => {
        const llistat = containerRef.current;
        if (llistat) {
            setShowOpacityLayerBottom(llistat.scrollHeight > llistat.clientHeight);
        }
    }, []);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 1) {
            setShowOpacityLayerBottom(false);
        } else if (scrollTop === 0) {
            setShowOpacityLayerTop(false);
        } else {
            setShowOpacityLayerBottom(true);
            setShowOpacityLayerTop(true);
        }
    };

    return (
        <div className={styles.modalMask}>
            <div className={styles.modalWrapper}>
                <div className={styles.modalContent}>
                    <div className={styles.controls}>
                        <div className={styles.controlsInner}>
                            <button onClick={removeModal}>
                                <Icona className={styles.iconaTancar} icona='tanca' alt='tanca' mida='24' isBlanc={false} />
                            </button>
                        </div>
                    </div>
                    <div className={styles.modalContainer}>
                        <div className={styles.capcalera}>
                            {mostraLogoPartits ? (
                                <div className={styles.contentLogoPartit}>
                                    <Imatge src={`${pathLogos}${getLogoPartit(id)}`} layout='fill' objectFit='contain' />
                                </div>
                            ) : (
                                <div className={styles.contentBoletaPartit}>
                                    <div
                                        className={styles.boletaPartit}
                                        style={{
                                            backgroundColor: rgbcolor
                                        }}
                                    ></div>
                                </div>
                            )}
                            <div className={styles.title}>
                                <div className={styles.nom}>{nom || id}</div>
                            </div>
                        </div>
                        <div className={styles.card} ref={containerRef} onScroll={handleScroll}>
                            <div className={styles.llistatCandidats}>
                                {canditats?.map((candidat, index) => {
                                    if (index < mnumitems)
                                        return (
                                            <div key={`candidat-${id}-${index}`}>
                                                {String(candidat?.num ?? '').padStart(2, '0')}. {candidat?.nom}
                                            </div>
                                        );
                                })}
                            </div>
                        </div>
                        {showOpacityLayerTop && <div className={styles.opacityLayerTop}></div>}
                        {showOpacityLayerBottom && <div className={styles.opacityLayerBottom}></div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

const CardElectes = (props) => {
    const { item, pathLogos, mostraLogoPartits } = props;
    const { canditats, id, mnumitems, nom, rgbcolor } = item;
    const { setModal, removeModal } = useModal();

    const stylesLlistatCandidats = clsx({
        [styles.llistatCandidats]: true,
        [styles.ambBoleta]: !mostraLogoPartits
    });
    const stylesCard = clsx({
        [styles.card]: true,
        [styles.ambBoleta]: !mostraLogoPartits
    });

    const handleOnClickLlista = () => {
        setModal(
            <ModalLlistat item={item} pathLogos={pathLogos} removeModal={removeModal} mostraLogoPartits={mostraLogoPartits} />,
            {
                className: styles.llistatElectes,
                closeOnClickOutside: true
            }
        );
    };

    return (
        <div className={stylesCard}>
            <div className={styles.capcalera}>
                {mostraLogoPartits ? (
                    <div className={styles.contentLogoPartit}>
                        <Imatge src={`${pathLogos}${getLogoPartit(id)}`} layout='fill' objectFit='contain' />
                    </div>
                ) : (
                    <div className={styles.contentBoletaPartit}>
                        <div
                            className={styles.boletaPartit}
                            style={{
                                backgroundColor: rgbcolor
                            }}
                        ></div>
                    </div>
                )}

                <div className={styles.title}>
                    <div className={styles.nom}>{nom || id}</div>
                </div>
            </div>
            <div className={stylesLlistatCandidats}>
                {canditats?.map((candidat, index) => {
                    if (index < mnumitems && index < 4)
                        return (
                            <div key={`candidat-${id}-${index}`}>
                                {candidat?.num}. {candidat?.nom}
                            </div>
                        );
                })}
            </div>
            {mnumitems > 4 && (
                <>
                    <div className={styles.opacityLayer}></div>
                    <div className={styles.peu}>
                        <div className={styles.linkLlistat} onClick={handleOnClickLlista}>
                            <span className={styles.linkText}>Tota la llista</span>
                            <Icona icona='fletxa_dreta' className={styles.linkIcona} inline={true} alt='' />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

const getColumns = (viewport, typesViewport) => {
    switch (viewport) {
        case typesViewport.VP_SMALL_MOBILE:
        case typesViewport.VP_MOBILE:
        case typesViewport.VP_SMALL:
            return 1;
        default:
            return 2;
    }
};

const LlistatElectes = (props) => {
    const { titol, items, pathLogos, mostraLogoPartits = false } = props;
    const { viewport, typesViewport } = useViewport();
    const [allLogosExists, setAllLogosExists] = useState(true);

    useEffect(() => {
        const checkFiles = async () => {
            try {
                const results = await Promise.all(
                    items.map((item) => {
                        const url = 'https:' + pathLogos + getLogoPartit(item.id);
                        return (async () => {
                            try {
                                const response = await fetch(url, { method: 'HEAD' });
                                return response.ok;
                            } catch {
                                return false;
                            }
                        })();
                    })
                );

                if (results.includes(false)) {
                    setAllLogosExists(false);
                }
            } catch (error) {
                setAllLogosExists(false);
            }
        };

        if (mostraLogoPartits && pathLogos) {
            checkFiles();
        }
    }, [mostraLogoPartits, pathLogos, items]);

    return items ? (
        <div className={styles.llistatElectesWrapper}>
            <Mosaic titol={titol} numColumns={getColumns(viewport, typesViewport)} hGap={300} vGap={400}>
                {items?.map((item, index) => {
                    return (
                        <div key={`llistat-partit-${index}`}>
                            <CardElectes
                                item={item}
                                pathLogos={pathLogos}
                                index={index}
                                mostraLogoPartits={allLogosExists && mostraLogoPartits ? true : false}
                            />
                        </div>
                    );
                })}
            </Mosaic>
        </div>
    ) : (
        <></>
    );
};

export default LlistatElectes;
